(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /*
   * A sortable, filterable list, live. Sort, a filter, a chip or a page link fetches the
   * caller's section alone and swaps the results body; the address bar follows, so a link
   * can be shared and Back undoes the last change. Below 990px the filter form moves into the
   * Filter sheet. With `data-paging="infinite"` the next page is added onto the grid as the
   * shopper nears its end, without touching the address bar.
   *
   * In a snippet, not a section: Shopify runs a section's script only on pages that render
   * that section, and both the search page and the collection page need this one.
   */
  class FacetsResults extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const { signal } = this.abort;

      this.classList.add('is-live');
      this.sheet = this.querySelector('[data-filters-sheet]');
      this.status = this.querySelector('[data-facets-status]');
      this.wide = matchMedia('(min-width: 990px)');

      this.addEventListener(
        'change',
        (event) => {
          if (!event.target.closest('[data-facets-form]') && !event.target.matches('[data-facets-sort]')) return;
          clearTimeout(this.timer);
          // An answer still on its way was asked before this change; landing now, it would
          // swap in a form without it and the next request would drop it.
          this.request?.abort();
          // Ticking three boxes in a row should be one request, not three.
          this.timer = setTimeout(() => this.submit(), event.target.type === 'number' ? 0 : 250);
        },
        { signal }
      );

      this.addEventListener(
        'submit',
        (event) => {
          if (!event.target.matches('[data-facets-form]')) return;
          event.preventDefault();
          this.submit();
        },
        { signal }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('[data-filters-open]')) return this.sheet.showModal();
          if (event.target.closest('[data-filters-close]') || event.target === this.sheet) return this.sheet.close();

          const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
          const next = event.target.closest('a[data-facets-next]');
          if (next && !modified) {
            event.preventDefault();
            return this.more(next, { focus: true });
          }

          const link = event.target.closest('a[data-facets-link]');
          if (!link || modified) return;
          event.preventDefault();
          this.go(link.href, { top: link.hasAttribute('data-facets-page-link') });
        },
        { signal }
      );

      addEventListener('popstate', () => this.go(location.href, { push: false }), { signal });
      this.wide.addEventListener('change', () => this.place(), { signal });

      if (this.dataset.paging === 'infinite') {
        // Early: the next page is on its way a screen before the last card is.
        this.near = new IntersectionObserver((entries) => entries.some((entry) => entry.isIntersecting) && this.more(entries[0].target), {
          rootMargin: '0px 0px 100% 0px',
        });
      }

      // The sort list: open, walk with the arrows, choose, and close on Escape, Tab or a click away.
      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('[data-sort-button]')) return this.sortOpen(this.querySelector('[data-sort-list]').hidden);
          const showAll = event.target.closest('[data-show-all]');
          if (showAll) return showAll.closest('.facets__group').classList.add('is-expanded');
          const option = event.target.closest('[data-sort-list] [role="option"]');
          if (option) this.sortChoose(option);
        },
        { signal }
      );
      this.addEventListener('keydown', (event) => this.sortKey(event), { signal });

      // The price slider moves live; the change it fires on release is what filters.
      this.addEventListener('input', (event) => event.target.matches?.('[data-range]') && this.slide(event.target), { signal });
      document.addEventListener(
        'pointerdown',
        (event) => !event.target.closest?.('.facets__sort') && this.sortOpen(false),
        { signal }
      );

      // The sticky bar and sidebar sit under the header when it sticks: measure it, and again
      // whenever its height changes with the width. A header that shrinks on scroll has shrunk
      // by the time the bar reaches it -- there is at least a page title between them -- so they
      // sit under its shrunk height, which it sets as --header-condensed-h.
      const header = document.querySelector('header')?.closest('.shopify-section');
      if (header) {
        const measure = () => {
          const bar = header.querySelector('.header--condenses');
          const shrunk = bar && parseFloat(getComputedStyle(bar).getPropertyValue('--header-condensed-h'));
          this.style.setProperty('--facets-top', `${getComputedStyle(header).position === 'sticky' ? shrunk || header.offsetHeight : 0}px`);
        };
        measure();
        this.headerSize = new ResizeObserver(measure);
        this.headerSize.observe(header);
      }

      this.place();
      this.watch();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.request?.abort();
      this.moreRequest?.abort();
      this.near?.disconnect();
      this.headerSize?.disconnect();
    }

    slide(input) {
      const range = input.closest('[data-price-range]');
      const low = range.querySelector('[data-range="low"]');
      const high = range.querySelector('[data-range="high"]');
      const max = Number(range.dataset.max);

      // A handle stops at the other rather than passing it.
      if (Number(low.value) > Number(high.value)) {
        if (input === low) low.value = high.value;
        else high.value = low.value;
      }
      low.classList.toggle('is-front', Number(low.value) >= max * 0.9);

      range.style.setProperty('--low', (low.value / max) * 100 + '%');
      range.style.setProperty('--high', (high.value / max) * 100 + '%');
      range.querySelector('[data-range-label="low"]').textContent = range.dataset.currency + low.value;
      range.querySelector('[data-range-label="high"]').textContent = range.dataset.currency + high.value;

      // A handle at its end is no limit at all: its field is left empty and drops out of the URL.
      const group = range.parentElement;
      group.querySelector('[data-range-field="low"]').value = Number(low.value) > 0 ? low.value : '';
      group.querySelector('[data-range-field="high"]').value = Number(high.value) < max ? high.value : '';
    }

    sortOpen(open) {
      const button = this.querySelector('[data-sort-button]');
      const list = this.querySelector('[data-sort-list]');
      if (!button || !list || list.hidden === !open) return;
      list.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      if (!open) return;
      this.sortActive(list.querySelector('[aria-selected="true"]') || list.querySelector('[role="option"]'));
      list.focus({ preventScroll: true });
    }

    sortActive(option) {
      const list = this.querySelector('[data-sort-list]');
      if (!option || !list) return;
      list.querySelector('.is-active')?.classList.remove('is-active');
      option.classList.add('is-active');
      list.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    sortChoose(option) {
      const select = this.querySelector('[data-facets-sort]');
      const button = this.querySelector('[data-sort-button]');
      this.sortOpen(false);
      button?.focus({ preventScroll: true });
      if (!select || select.value === option.dataset.value) return;

      this.querySelectorAll('[data-sort-list] [role="option"]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      this.querySelector('[data-sort-current]').textContent = option.textContent.trim();
      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sortKey(event) {
      const button = event.target.closest?.('[data-sort-button]');
      const list = event.target.closest?.('[data-sort-list]');
      if (button && ['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        return this.sortOpen(true);
      }
      if (!list) return;

      const options = [...list.querySelectorAll('[role="option"]')];
      const at = options.indexOf(list.querySelector('.is-active'));
      const moves = { ArrowDown: at + 1, ArrowUp: at - 1, Home: 0, End: options.length - 1 };
      if (event.key in moves) {
        event.preventDefault();
        return this.sortActive(options[Math.max(0, Math.min(options.length - 1, moves[event.key]))]);
      }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        return options[at] && this.sortChoose(options[at]);
      }
      if (event.key === 'Escape' || event.key === 'Tab') {
        if (event.key === 'Escape') event.preventDefault();
        this.sortOpen(false);
        this.querySelector('[data-sort-button]')?.focus({ preventScroll: true });
      }
    }

    // The one filter form sits in the sidebar from 990px and in the sheet below that.
    place() {
      const form = this.querySelector('[data-facets-form]');
      const body = this.querySelector('[data-facets-body]');
      this.sheet.querySelector('[data-filters-show]').textContent = body?.dataset.showLabel || '';

      if (!form) return this.sheet.open && this.sheet.close();
      const home = this.wide.matches ? this.querySelector('[data-filters-home]') : this.sheet.querySelector('[data-filters-slot]');
      if (form.parentElement !== home) home.replaceChildren(form);
      // Nothing left behind in the sidebar's place, so it takes no room above the results.
      if (!this.wide.matches) this.querySelector('[data-filters-home]')?.replaceChildren();
      if (this.wide.matches) {
        this.sheet.querySelector('[data-filters-slot]').replaceChildren();
        if (this.sheet.open) this.sheet.close();
      }
    }

    // Infinite paging watches the current "load more"; there is a new one after every load.
    watch() {
      if (!this.near) return;
      this.near.disconnect();
      const next = this.querySelector('[data-facets-next]');
      if (next) this.near.observe(next);
    }

    submit() {
      const form = this.querySelector('[data-facets-form]');
      const url = new URL(form.action, location.origin);
      for (const [name, value] of new FormData(form)) {
        // An empty price box is no limit, not a limit of nothing.
        if (value !== '') url.searchParams.append(name, value);
      }
      this.go(url.href);
    }

    // Shopify writes the section_id it was asked with into the links it renders; a link opened
    // in a new tab or copied must be the page, not the bare section.
    clean(root) {
      root.querySelectorAll('a[data-facets-link], a[data-facets-next]').forEach((link) => {
        const url = new URL(link.href, location.origin);
        url.searchParams.delete('section_id');
        link.href = url;
      });
    }

    async fetchBody(href, signal) {
      const url = new URL(href, location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error(response.status);
      const body = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-facets-body]');
      if (!body) throw new Error('No results body');
      return body;
    }

    async go(href, { push = true, top = false } = {}) {
      // A link, Back or a submit overrides a change still waiting to be sent, and a page
      // still loading onto the old grid.
      clearTimeout(this.timer);
      this.request?.abort();
      this.moreRequest?.abort();
      const request = (this.request = new AbortController());
      const url = new URL(href, location.origin);
      url.searchParams.delete('section_id');

      this.setAttribute('aria-busy', 'true');
      try {
        const fresh = await this.fetchBody(url, request.signal);

        const focused = document.activeElement?.id;
        const inside = this.contains(document.activeElement);
        // Groups the shopper opened or closed stay that way.
        const open = [...this.querySelectorAll('.facets__group')].map((group) => group.open);
        const expanded = [...this.querySelectorAll('.facets__group.is-expanded')].map((group) => group.id);
        this.querySelector('[data-facets-body]').replaceWith(fresh);
        // The sheet holds the old form; the fresh one arrives in the sidebar's slot.
        this.sheet.querySelector('[data-filters-slot]').replaceChildren();
        this.place();
        this.querySelectorAll('.facets__group').forEach((group, index) => {
          if (open[index] !== undefined) group.open = open[index];
          if (expanded.includes(group.id)) group.classList.add('is-expanded');
        });
        this.clean(fresh);
        // Back to the control that was used; a chip that removed itself leaves the count.
        const target = (focused ? document.getElementById(focused) : null) || (inside ? this.querySelector('#facets-count') : null);
        target?.focus({ preventScroll: true });

        if (push) history.pushState(null, '', url);
        this.status.textContent = fresh.dataset.status;
        if (top) this.scrollIntoView({ block: 'start' });
        this.watch();
      } catch (error) {
        if (request.signal.aborted) return;
        // A failed update must not strand the shopper on stale results: load it for real.
        location.href = url;
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }

    // The next page, added onto the grid. The address bar stays: a reload starts at the top.
    async more(link, { focus = false } = {}) {
      // Already on its way: the observer and a press can both ask for the same page.
      if (link.hasAttribute('aria-busy')) return;
      this.moreRequest?.abort();
      const request = (this.moreRequest = new AbortController());
      link.setAttribute('aria-busy', 'true');

      try {
        const fresh = await this.fetchBody(link.href, request.signal);
        const grid = this.querySelector('[data-facets-grid]');
        const incoming = fresh.querySelector('[data-facets-grid]');
        if (!grid || !incoming) throw new Error('No grid');

        // A piece that moved between pages while the shopper scrolled is not shown twice.
        const key = (card) => new URL(card.querySelector('a[href]')?.href || '', location.origin).pathname;
        const known = new Set([...grid.children].map(key));
        const added = [...incoming.children].filter((card) => !known.has(key(card)));
        grid.append(...added);

        const more = this.querySelector('[data-facets-more]');
        const freshMore = fresh.querySelector('[data-facets-more]');
        if (more && freshMore) more.replaceWith(freshMore);
        const pages = this.querySelector('.pagination');
        const freshPages = fresh.querySelector('.pagination');
        if (pages && freshPages) pages.replaceWith(freshPages);
        this.clean(this.querySelector('[data-facets-body]'));

        this.status.textContent = freshMore?.querySelector('.facets__showing')?.textContent.trim() || '';
        if (focus) added[0]?.querySelector('a[href]')?.focus();
        this.watch();
      } catch (error) {
        if (request.signal.aborted) return;
        // The link is a real next page: follow it rather than leave the grid stuck.
        location.href = link.href;
      } finally {
        if (this.moreRequest === request) link.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('facets-results', FacetsResults);
  } catch(e) { console.error(e); }
})();

})();
